import { IconButton, Link } from '@mui/material';
import Close from '@mui/icons-material/Close';
import React from 'react';
import { AppliedEventFilter } from './useAppliedEventFilters';

import styles from './EventCatalogFilterTags.module.scss';

interface EventCatalogFilterTagsProps {
  filters: AppliedEventFilter[];
  onRemove: (filter: AppliedEventFilter) => void;
  onClear: () => void;
}

const EventCatalogFilterTags: React.FunctionComponent<EventCatalogFilterTagsProps> = ({ filters, onRemove, onClear }) =>
  filters.length ? (
    <div className={styles.container}>
      {filters.map((filter) => {
        const { key, label, value, displayValue } = filter;

        return (
          <span className={styles.tag} key={`filter-tag-${key}-${value}`}>
            <span className={styles.tagLabel}>{`${label}:`}</span>
            <span className={styles.tagValue}>{displayValue}</span>
            <IconButton
              size={'small'}
              className={styles.removeButton}
              aria-label={`Remove ${label} ${displayValue} filter`}
              onClick={() => onRemove(filter)}
            >
              <Close fontSize={'inherit'} />
            </IconButton>
          </span>
        );
      })}
      {filters.length > 1 && (
        <Link component={'button'} underline={'always'} className={styles.clearAll} onClick={onClear}>
          {'Clear all'}
        </Link>
      )}
    </div>
  ) : null;
export default EventCatalogFilterTags;
